let forms = {
    'module-entity-form-default': require('@/components/module/forms/Default.vue').default,
}

export default forms
